import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import { getAllAnswers } from '../../utils/onboardingStorage'

export default function FeedbackGreatToMeetYouPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [userName, setUserName] = useState<string>('')

  useEffect(() => {
    const allAnswers = getAllAnswers()
    const displayNameAnswer = allAnswers.display_name
    if (displayNameAnswer?.answer) {
      setUserName(displayNameAnswer.answer)
    }
  }, [])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <FeedbackPage
      emoji="🎉"
      heading={t('pages.onboarding.feedbackGreatToMeetYou.heading', {
        name: userName,
      })}
      text={t('pages.onboarding.feedbackGreatToMeetYou.text')}
      onSubmit={handleSubmit}
    />
  )
}
